import React, { Component } from 'react';
import { Link } from 'react-router';
import ShareButton from '../ShareButton';

import './style.css';

import StudentSideBar from '../StudentSideBar';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import StudentAppBar from '../StudentAppBar';

import AdmissionApi from "../../Services/AdmissionApi";

class StudentAlertDetail extends Component {
  admissionsService = new AdmissionApi()

  state = {
    isOpen: window.innerWidth < 980 ? false : true,
    disableFav: false
  }

  createMarkup = (data) => {
    if (data) {
      return { __html: data };
    } else {
      return { __html: <p></p> };
    }
  }

  updateState = (response) => {
    const applyLink = this.props.location.state.data.apply_link
    if (response.data.success) {
      if (applyLink) window.open(applyLink)
    } else {
      this.setState({ disableFav: false })
    }
  }

  onApplyNow = () => {
    const data = this.props.location.state.data
    this.setState({ disableFav: true })

    let obj = {
      alertType: 1, // 1 for admission alerts and 2 for scholarship
      alertId: data.id,
      userRole: 'student',
      userId: localStorage.getItem('userId')
    };

    this.admissionsService.createNew(
      this.updateState,
      obj,
      `v1/alerts/favourites`
    )
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  render() {
    const data = this.props.location.state.data
    const { isOpen, disableFav } = this.state

    const listItems = JSON.parse(data.keydate_activity).map((item, i) =>
      <tr key={item.id}>
        <td>{i + 1}</td>
        <td>{item.activity}</td>
        <td>{item.activity_date}</td>
      </tr>
    )

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="Admission Alerts Details" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">
              <section className="dash-alert-details">
                <nav className="mb-4">
                  <ol className="breadcrumb alert-breadcrumb">
                    <li className="breadcrumb-item"><Link to="/AdmissionAlerts">Admission Alerts</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{data.institution_name}</li>
                  </ol>
                </nav>

                <div className="row">
                  <div className="col-lg-3 mb-3">
                    <div className="nav flex-column nav-pills alert-tab" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a className="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#info" role="tab">General Information</a>
                      <a className="nav-link" id="v-pills-home-tab" data-toggle="pill" href="#offerings" role="tab">Courses Offered</a>
                      <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#process" role="tab">Application Process</a>
                      <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#eligible" role="tab">Eligibility</a>
                      <a className={`nav-link ${!data.entrance_test_pattern && 'd-none'}`} id="v-pills-messages-tab" data-toggle="pill" href="#pattern" role="tab">Entrance test pattern</a>
                      <a className="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#dates" role="tab">Key Dates</a>
                      <a className={`nav-link ${!data.important_link && 'd-none'}`} id="v-pills-settings-tab" data-toggle="pill" href="#links" role="tab">Important Links</a>
                    </div>
                    <button disabled={!!data.isFavourite || !data.apply_link || disableFav} className="admn-cta-btn w-100 mt-3" onClick={this.onApplyNow}>Apply Now</button>
                    <ShareButton />
                  </div>
                  <div className="col-lg-9 pl-lg-0">
                    <div className="tab-content alert-tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade show active" id="info">
                        {data.description ? <div dangerouslySetInnerHTML={this.createMarkup(data.description)}></div> : ""}
                      </div>
                      <div className="tab-pane fade show" id="offerings">
                        {data.programs_offered ? <div dangerouslySetInnerHTML={this.createMarkup(data.programs_offered)}></div> : ""}
                      </div>
                      <div className="tab-pane fade" id="process">
                        {data.admission_process ? <div dangerouslySetInnerHTML={this.createMarkup(data.admission_process)}></div> : ""}
                      </div>
                      <div className="tab-pane fade" id="eligible">
                        {data.eligibility ? <div dangerouslySetInnerHTML={this.createMarkup(data.eligibility)}></div> : ""}
                      </div>
                      <div className="tab-pane fade" id="pattern">
                        {data.entrance_test_pattern ? <div dangerouslySetInnerHTML={this.createMarkup(data.entrance_test_pattern)}></div> : ""}
                      </div>
                      <div className="tab-pane fade" id="dates">
                        <table className="table table-responsive alert-table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Key Event</th>
                              <th scope="col">Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listItems}
                          </tbody>
                        </table>
                      </div>
                      <div className="tab-pane fade" id="links">
                        {data.important_link ? <div dangerouslySetInnerHTML={this.createMarkup(data.important_link)}></div> : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default StudentAlertDetail;



/** WEBPACK FOOTER **
 ** ./src/components/AlertDetail/index.js
 **/